<template>
  <div>
    <v-container class="pa-0" fluid>
      <IncidentsDetailPolitical
        v-if="isPolitical"
        :feature="feature"
      ></IncidentsDetailPolitical>

      <IncidentsDetailMaritime
        v-if="!isPolitical"
        :feature="feature"
      ></IncidentsDetailMaritime>

      <div v-if="!feature">
        <Loader size="small" color="black" text="" class="ml-2 pt-10"></Loader>
      </div>
    </v-container>
  </div>
</template>

<script>
import lodashGet from "lodash/get";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_HOME } from "@/store";

export default {
  name: "IncidentsDetail",
  components: {
    Loader: () => import("@/components/common/Loader"),
    IncidentsDetailPolitical: () =>
      import("@/components/controlRisks/incidents/IncidentsDetailPolitical"),
    IncidentsDetailMaritime: () =>
      import("@/components/controlRisks/incidents/IncidentsDetailMaritime"),
  },
  computed: {
    ...mapGetters({
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
    feature() {
      if (lodashGet(this.detailsSidebar, "feature")) {
        return this.detailsSidebar.feature;
      }
      return null;
    },
    isPolitical() {
      if (lodashGet(this.detailsSidebar, "feature.politicalEnabled")) {
        return this.detailsSidebar.feature.politicalEnabled;
      }
      return null;
    },
  },
};
</script>

<style scoped></style>
